import type { ReactNode } from "react";

export function PublicFooter({ children }: { children: ReactNode }) {
  return (
    <footer className="border-t border-slate-200 bg-white px-6 py-3 text-center text-xs text-slate-400">
      {children}
    </footer>
  );
}
